import React from "react";

import {
  ERROR_COLOR,
  NEUTRAL_BLACK_COLOR,
  NEUTRAL_DARK_COLOR,
  NEUTRAL_LIGHT_COLOR,
} from "./constants";
import { OptionType, TextFieldVariant } from "./types";

// Parse option data with type safety, providing defaults
export function getOptionData<OptionData>(option: OptionType<OptionData>): OptionType<OptionData> {
  return {
    value: option.value,
    label: option.label,
    badge: option.badge ?? "",
    disabled: option.disabled ?? false,
    data: option.data
  };
}

interface InputColors {
  inputBaseColor: string;
  inputOverlayColor: string;
}

interface GetInputColorsProps {
  effectiveDisabled: boolean;
  error: boolean;
  hovered: boolean;
}

const getBaseInputColors = ({ hovered }: Pick<GetInputColorsProps, 'hovered'>): Pick<InputColors, 'inputBaseColor'> => {
  const inputBaseColor = hovered ? NEUTRAL_BLACK_COLOR : NEUTRAL_DARK_COLOR;
  return { inputBaseColor };
};

const getOverlayInputColors = ({ error, hovered }: Pick<GetInputColorsProps, 'error' | 'hovered'>): Pick<InputColors, 'inputOverlayColor'> => {
  let inputOverlayColor = NEUTRAL_DARK_COLOR;
  if (error) {
    inputOverlayColor = ERROR_COLOR;
  } else if (hovered) {
    inputOverlayColor = NEUTRAL_BLACK_COLOR;
  }
  return { inputOverlayColor };
};

export const getInputColors = ({
  effectiveDisabled,
  error,
  hovered,
}: GetInputColorsProps): InputColors => {
  if (effectiveDisabled) {
    return {
      inputBaseColor: NEUTRAL_LIGHT_COLOR,
      inputOverlayColor: NEUTRAL_LIGHT_COLOR,
    };
  }

  const { inputBaseColor } = getBaseInputColors({ hovered });
  const { inputOverlayColor } = getOverlayInputColors({ error, hovered });

  return { inputBaseColor, inputOverlayColor };
};

export function getCursorStyle(effectiveDisabled: boolean, variant: TextFieldVariant): React.CSSProperties['cursor'] {
  if (effectiveDisabled) {
    return "default"
  }

  return variant === "select" ? "pointer" : "text";
}
